<template>
  <div class="home_page" >
    <div class="goods_category_list">
      <div class="search_title">筛选条件</div>
      <!-- 目录 -->
      <el-row
        class="category_row rel"
        v-if="categoryList && categoryList.length"
      >
        <el-col :span="3" class="row_lable"
          >{{ $t("product.catalog") }}：</el-col
        >
        <el-col :span="20">
          <el-row
            v-for="(ele, idx) in Math.ceil(categoryList.length / 8)"
            :key="idx"
            class="rfw jfs"
          >
            <div
              v-for="item in categoryList.slice(idx * 8, idx * 8 + 8)"
              :key="item.categoryId || item.foregroundCategoryId"
              v-show="showMoreCategory || idx == 0"
              class="category-item"
            >
              <SelectedChild
                :active="categoryParentList.length === 3"
                :item="item"
                @choosedCategory="choosedCategory"
              />
            </div>
          </el-row>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="categoryList.length > 8"
          style="padding: 12px 0 0"
        >
          <div
            class="more-button cursor-pointer"
            @click.stop="showMoreCategory = !showMoreCategory"
          >
            {{ !showMoreCategory ? $t("common.more") : $t("common.collapse") }}
            <i
              :class="
                showMoreCategory ? 'el-icon-arrow-up' : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <!-- 品牌 -->
      <el-row class="category_row">
        <el-col :span="3" class="row_lable">{{ $t("common.brand") }}：</el-col>
        <el-col :span="20">
          <span v-show="!brandList.length">&nbsp;</span>
          <!-- 首字母检索列表 -->
          <div v-if="letterBrandList.length && showMoreBrand" class="letter">
            <span
              class="letter-item"
              :class="{ 'letter-choosed': letter === brandLetterVal }"
              v-for="letter in letterBrandList"
              :key="letter"
              @click="changeBrandLetterVal(letter)"
              >{{ letter || $t("common.all") }}</span
            >
          </div>
          <el-row
            v-for="(ele, idx) in Math.ceil(showBrandList.length / 8)"
            :key="idx"
            class="rfw jfs"
          >
            <div
              :span="3"
              class="category-item"
              v-for="item in showBrandList.slice(idx * 8, idx * 8 + 8)"
              :key="item.brandId"
              v-show="showMoreBrand || idx == 0"
            >
              <span
                :class="
                  'ellipsis cursor-pointer item_span ' +
                  (item.selected ? 'item_select' : '')
                "
                @click="choosedBrand(item)"
                :title="item.name"
                >{{ item.name }}</span
              >
            </div>
          </el-row>
          <div
            class="rf jc"
            v-if="
              brandLetterVal &&
              showMoreBrand &&
              !(brandPage <= 1 && !conditionType.brandHasMore)
            "
          >
            <el-button
              size="mini"
              class="category-item-button"
              @click.stop="brandChangePage('brand', brandPage - 1)"
              :disabled="brandPage <= 1"
              >{{ $t("common.previous") }}</el-button
            >
            <el-button
              size="mini"
              class="category-item-button"
              @click.stop="brandChangePage('brand', brandPage + 1)"
              :disabled="!conditionType.brandHasMore"
              >{{ $t("common.next") }}</el-button
            >
          </div>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="brandList.length > 8 || brandPage > 1 || brandLetterVal"
        >
          <div class="more-button cursor-pointer" @click.stop="getAllBrand()">
            {{ !showMoreBrand ? $t("common.more") : $t("common.collapse") }}
            <i
              :class="
                showMoreBrand ? 'el-icon-arrow-up' : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <!-- 系列 -->
      <el-row
        class="category_row"
        v-if="showSeriesList && showSeriesList.length > 0"
      >
        <el-col :span="3" class="row_lable"
          >{{ $t("common.collection") }}：</el-col
        >
        <el-col :span="20">
          <span v-show="!seriesList.length">&nbsp;</span>
          <el-row
            v-for="(ele, idx) in Math.ceil(showSeriesList.length / 8)"
            :key="idx"
            class="rfw jfs"
          >
            <div
              class="ellipsis category-item"
              v-for="item in showSeriesList.slice(idx * 8, idx * 8 + 8)"
              :key="item.seriesId"
              v-show="showMoreSeries || idx == 0"
            >
              <span
                :class="
                  'ellipsis cursor-pointer item_span ' +
                  (item.selected ? 'item_select' : '')
                "
                @click="choosedSeries(item)"
                :title="item.name"
                >{{ item.name }}</span
              >
            </div>
          </el-row>
          <div
            class="rf jc"
            v-if="
              showMoreSeries &&
              !(seriesPage <= 1 && !conditionType.seriesHasMore)
            "
          >
            <el-button
              size="mini"
              class="category-item-button"
              @click.stop="brandChangePage('series', seriesPage - 1)"
              :disabled="seriesPage <= 1"
              >{{ $t("common.previous") }}</el-button
            >
            <el-button
              size="mini"
              class="category-item-button"
              @click.stop="brandChangePage('series', seriesPage + 1)"
              :disabled="!conditionType.seriesHasMore"
              >{{ $t("common.next") }}</el-button
            >
          </div>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="seriesList.length > 8 || showMoreSeries"
        >
          <div class="more-button cursor-pointer" @click.stop="getAllSeries">
            {{ !showMoreSeries ? $t("common.more") : $t("common.collapse") }}
            <i
              :class="
                showMoreSeries ? 'el-icon-arrow-up' : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <!-- 属性 -->
      <el-row
        class="category_row"
        v-for="(attribute, attIndex) in attributeList"
        :key="attribute.attributeItemId"
      >
        <el-col :span="3" class="row_lable">{{ attribute.name }}：</el-col>
        <el-col :span="20">
          <span v-show="!attribute.attributeValueWithSelectedList.length"
            >&nbsp;</span
          >
          <el-row
            v-for="(ele, idx) in Math.ceil(
              attribute.attributeValueWithSelectedList.slice(0, 80).length / 8
            )"
            :key="idx"
            class="rfw jfs"
          >
            <div
              class="ellipsis category-item"
              v-for="item in attribute.attributeValueWithSelectedList
                .slice(0, 80)
                .slice(idx * 8, idx * 8 + 8)"
              :key="item.attributeValueId"
              v-show="showMoreAttributeList[attIndex] || idx == 0"
            >
              <span
                :class="
                  'ellipsis cursor-pointer item_span ' +
                  (item.selected ? 'item_select' : '')
                "
                @click="choosedAttribute(item)"
                :title="item.name"
                >{{ item.name }}</span
              >
            </div>
          </el-row>
        </el-col>
        <el-col
          :span="2"
          class="category-more"
          v-show="attribute.attributeValueWithSelectedList.length > 8"
        >
          <div
            class="more-button cursor-pointer"
            @click.stop="changeMore(attIndex)"
          >
            {{
              !showMoreAttributeList[attIndex]
                ? $t("common.more")
                : $t("common.collapse")
            }}
            <i
              :class="
                showMoreAttributeList[attIndex]
                  ? 'el-icon-arrow-up'
                  : ' el-icon-arrow-down'
              "
            ></i>
          </div>
        </el-col>
      </el-row>
      <div
        class="search_show_more_box"
        v-show="conditionType.attributeHasMore || attributeList.length > 8"
      >
        <el-button
          type="text"
          class="search_show_more search_show_more_down"
          v-if="!conditionType.attributeHasMore"
          @click="brandChangePage('attribute', 1)"
          >点击收起
          <img src="@/assets/img/good/searchMore.png" alt="" srcset=""
        /></el-button>
        <el-button
          type="text"
          class="search_show_more"
          v-else
          @click="brandChangePage('attribute', attributePage + 1, 99)"
          >展开更多筛选<img
            src="@/assets/img/good/searchMore.png"
            alt=""
            srcset=""
        /></el-button>
      </div>
    </div>
    <!-- 已选： -->
    <div class="selected-wrap">
      <div class="selected-lable">已选：</div>
      <div class="selected">
        <div class="child-item" v-if="categoryParentList.length > 0">
          <span>目录：</span>
          {{ categoryParentList.map((v) => v.categoryName).join("＞") }}
          <div v-if="categoryParentList.length" class="line"></div>
          <img
            v-if="categoryParentList.length"
            class="cancel"
            @click="setFirstCategory"
            src="~@/assets/img/premium/cancel.png"
          />
        </div>
        <div
          class="child-item"
          v-for="(item, index) in brandList.filter((v) => v.selected)"
          :key="index"
        >
          <span>品牌：</span>
          {{ item.name }}
          <div class="line"></div>
          <img
            class="cancel"
            @click="choosedBrand(item)"
            src="~@/assets/img/premium/cancel.png"
          />
        </div>
        <div
          class="child-item"
          v-for="(item, index) in seriesList.filter((v) => v.selected)"
          :key="`${index}-index`"
        >
          <span>系列：</span>
          {{ item.name }}
          <div class="line"></div>
          <img
            class="cancel"
            @click="choosedSeries(item)"
            src="~@/assets/img/premium/cancel.png"
          />
        </div>
        <div
          class="sel-item"
          v-for="item in attributeList"
          :key="item.attributeItemId"
        >
          <template
            v-if="
              item.attributeValueWithSelectedList.filter((v) => v.selected)
                .length
            "
          >
            <div
              class="child-item"
              v-for="(
                item2, index2
              ) in item.attributeValueWithSelectedList.filter(
                (v) => v.selected
              )"
              :key="`${index2}-index2`"
            >
              <span>{{ item.name }}：</span>
              {{ item2.name }}
              <div class="line"></div>
              <img
                class="cancel"
                @click="choosedAttribute(item2)"
                src="~@/assets/img/premium/cancel.png"
              />
            </div>
          </template>
        </div>
      </div>
      <div class="clear-all" @click="clearAll">
        <img
          class="cancel"
          src="~@/assets/img/premium/cancel.png"
        />清空筛选结果
      </div>
    </div>
    <!-- 排序 -->
    <el-row class="good_sort">
      <el-input
        class="input-search"
        placeholder="商品名称"
        maxlength="200"
        v-model="oldGoodsName"
        @blur="setStrQuery"
        @keyup.enter.native="setStrQuery"
      ></el-input>
      <el-input
        class="input-search"
        placeholder="商品编码"
        maxlength="200"
        v-model="oldGoodsCode"
        @blur="setStrQuery"
        @keyup.enter.native="setStrQuery"
      ></el-input>
      <el-input
        class="input-search"
        placeholder="商品标签"
        maxlength="200"
        v-model="customerLabel"
        @blur="setStrQuery"
        @keyup.enter.native="setStrQuery"
      ></el-input>
      <template v-if="isShowDesc">
        <div
          class="default_sort_but cursor-pointer"
          @click="defaultSortHandle"
          :class="{ good_sort_default: !salesDesc && !priceDesc }"
        >
          {{ $t("product.default") }}
        </div>
        <div
          class="sort_item cursor-pointer"
          :class="{ sort_item_selected: salesDesc }"
          @click="changeSortStatus('salesDesc')"
        >
          {{ $t("product.sales") }}
          <div class="sort_status">
            <i
              class="el-icon-caret-top"
              :class="{ sort_status_selected: salesDesc === 'false' }"
            ></i>
            <i
              class="el-icon-caret-bottom"
              :class="{ sort_status_selected: salesDesc === 'true' }"
            ></i>
          </div>
        </div>
        <div
          class="sort_item cursor-pointer"
          :class="{ sort_item_selected: priceDesc }"
          @click="changeSortStatus('priceDesc')"
        >
          {{ $t("product.price") }}
          <div class="sort_status">
            <i
              class="el-icon-caret-top"
              :class="{ sort_status_selected: priceDesc === 'false' }"
            ></i>
            <i
              class="el-icon-caret-bottom"
              :class="{ sort_status_selected: priceDesc === 'true' }"
            ></i>
          </div>
        </div>
      </template>
    </el-row>
  </div>
</template>
<script>
import SelectedChild from "./selectedChild.vue";
export default {
  props: {
    pageName: {
      type: String,
      default: () => "",
    },
    isShowDesc: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: String,
      default: () => "02",
    },
  },

  data() {
    return {
      loading:false,
      oldGoodsName: "",
      oldGoodsCode: "",
      customerLabel: "",
      salesDesc: "",
      priceDesc: "",
      popularityDesc: "",
      conditionTypeObj: {}, // 后台返回的参数
      brandList: [], // 品牌列表
      brandPage: 1, // 品牌分页
      brandLetterVal: "", // 品牌首字母
      attributeList: [], // 属性列表
      boutiqueCategoryTree: {}, // 暂存的分类
      commodityCategoryTreeVo: {}, // // 暂存的分类
      attributePage: 1,
      seriesList: [], // 系列列表
      seriesPage: 1, // 品牌分页
      showMoreCategory: false, // 显示更多类目
      showMoreBrand: false, // 显示更多品牌
      showMoreSeries: false, // 显示更多系列
      showMoreAttributeList: [], // 属性显示更多
      categoryList: [], // 当前选中类目的下级
      categoryParentList: [], // 当前选中类目的所有上级，包含自己
    };
  },
  components: {
    SelectedChild,
  },
  computed: {
    conditionType() {
      return this.conditionTypeObj;
    },
    // ---
    // 品牌的类目检索
    letterBrandList() {
      let list = this.conditionTypeObj.brandInitialsList || [];
      if (list.length) {
        list.unshift("");
      }
      return list;
    },
    // 页面显示的品牌
    showBrandList() {
      // let brandList = []
      if (!this.showMoreBrand) {
        // 默认显示8个
        return this.brandList.slice(0, 8);
      } else {
        return this.brandList;
      }
    },
    // 页面显示的系列
    showSeriesList() {
      if (!this.showMoreSeries) {
        // 默认显示8个
        return this.seriesList.slice(0, 8);
      } else {
        return this.seriesList;
      }
    },
    // 类目主键(选中类目跳转)
    foregroundCategoryId() {
      return this.$route.query.foregroundCategoryId || "";
    },
    // 选中品牌主键列表
    brandIdList() {
      if (this.$route.query.brandIdList) {
        return this.$route.query.brandIdList.split(",");
      } else {
        return [];
      }
    },
    // 选中系列主键列表
    seriesNameList() {
      if (this.$route.query.seriesNameList) {
        return this.$route.query.seriesNameList.split(",");
      } else {
        return [];
      }
    },
    // 选中属性值主键列表
    attributeNameValueList() {
      if (this.$route.query.attributeNameValueList) {
        return this.$route.query.attributeNameValueList.split("^^");
      } else {
        return [];
      }
    },
  },
  watch: {
    "$route.query": {
      handler: "getCategory",
      immediate: false,
    },
  },
  mounted() {
    // if (window.screen.width < 750) {
    //   this.jumpH5();
    //   return;
    // }
    this.getCategory();
    this.getCategoryTree();
  },
  methods: {
    setStrQuery() {
      this.$router.push({
        name: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList || "",
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeNameValueList:
            this.brandIdList.length || this.seriesNameList.length
              ? this.$route.query.attributeNameValueList
              : "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
          oldGoodsName: this.oldGoodsName,
          oldGoodsCode: this.oldGoodsCode,
          customerLabel: this.customerLabel,
        },
      });
    },
    // 获取二三级分类
    getCategoryTree() {
      // categoryList：选中类目的下级
      // categoryParentList：选中类目的父级链
      // commodityCategoryTreeVo：1级类目-3级类目集合
      // foregroundCategoryId：当前进来时候的类目

      if (this.categoryParentList.length === 0 && this.foregroundCategoryId) {
        this.categoryParentList = this.getChoosedList(
          [...this.commodityCategoryTreeVo.children],
          this.foregroundCategoryId
        );
      }
      this.categoryList = this.commodityCategoryTreeVo.children;
    },
    clearAll() {
      this.$router.push({
        path: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: "",
          brandIdList: "",
          seriesNameList: "",
          attributeNameValueList: "",
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          oldGoodsName: "",
          oldGoodsCode: "",
          customerLabel: "",
        },
      });
      this.categoryParentList = [];
      this.getCategory();
      // this.getCategoryTree()
    },
    toHome() {
      this.$router.push({ name: "home" });
    },
    // ------202205011 优化分页
    changeBrandLetterVal(val) {
      this.brandLetterVal = val;
      this.brandChangePage("brand", 1);
    },
    // 品牌系列上一页下一页
    brandChangePage(type, curPage) {
      // if (type === 'attribute' && curPage = 1) {}
      this.getCategory(type, curPage);
    },
    // 获取品牌默认的40条
    getAllBrand() {
      this.showMoreBrand = !this.showMoreBrand;
      this.brandPage = 1;
      this.brandLetterVal = "";
      if (!this.showMoreBrand) {
        this.brandChangePage("brand", 1);
      }
    },
    // 获取系列默认的40条
    getAllSeries() {
      this.showMoreSeries = !this.showMoreSeries;
      this.seriesPage = 1;
      if (!this.showMoreSeries) {
        this.brandChangePage("series", 1);
      }
    },
    // -----end--
    // 更改属性显示隐藏
    changeMore(index) {
      this.$set(
        this.showMoreAttributeList,
        index,
        !this.showMoreAttributeList[index]
      );
    },
    // 查询当前类目的所有上级
    getChoosedList(dataList, keyId, result = []) {
      if (dataList && dataList.length) {
        let index = dataList.findIndex((item) => {
          return item.categoryId + "" === keyId;
        });
        if (index > -1) {
          result.unshift(dataList[index]);
          if (!dataList[index].parentId) {
            return result;
          } else {
            let list = this.commodityCategoryTreeVo
              ? [this.commodityCategoryTreeVo]
              : [];

            this.getChoosedList(list, dataList[index].parentId, result);
          }
        } else {
          dataList.forEach((item) => {
            this.getChoosedList(item.children, keyId, result);
          });
        }
      }
      return result;
    },
    // 更新选中的类目返回筛选条件列表
    getCategory(pageConditionType, page = 0) {
      pageConditionType =
        typeof pageConditionType === "string" ? pageConditionType : "";

      this.oldGoodsName = this.$route.query.oldGoodsName || "";
      this.oldGoodsCode = this.$route.query.oldGoodsCode || "";
      this.customerLabel = this.$route.query.customerLabel || "";

      let params = {
        attrLimit: 6,
        search: this.$route.query.search || "", // 搜索内容
        brandIdList: this.brandIdList, // 品牌主键列表
        seriesNameList: this.seriesNameList, // 系列主键列表
        attributeNameValueList: this.attributeNameValueList, // 属性值主键列表
        oldGoodsName: this.oldGoodsName,
        oldGoodsCode: this.oldGoodsCode,
        customerLabel: this.customerLabel,
        tab: this.tab,
        companyId: this.$store.state.user.defaultCompanyId,
      };

      let categoryId = this.foregroundCategoryId;
      if (this.categoryParentList && this.categoryParentList.length) {
        categoryId =
          this.categoryParentList[this.categoryParentList.length - 1]
            .categoryId;
      }
      params.foregroundCategoryId = categoryId;

      // console.log('pageConditionType',pageConditionType)
      // 处理查询条件的分页
      if (pageConditionType) {
        params["page"] = page; // ++this[pageConditionType + 'Page']
        if (pageConditionType === "brand") {
          params["brandInitials"] = this.brandLetterVal;
        }
      } else {
        this.postSearchParams();
        this.attributePage = 1;
        // this.refushDataList(1);
        this.showMoreBrand = false;
        this.showMoreSeries = false;
      }
      this.loading = true
      this.$http
        .post(
          `/front/commodity-user/web/cloud-warehouse/lclbConditions?conditionType=${
            pageConditionType || ""
          }`,
          params
        )
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false;
          }
          // 品牌
          if (pageConditionType === "brand") {
            this.conditionTypeObj.brandHasMore = res.data.brandHasMore || false;
            this.brandPage = res.data.currentPage || 1;
            this.brandList = res.data.brandWithSelectedList || [];
          } else if (pageConditionType === "series") {
            // 系列
            this.conditionTypeObj.seriesHasMore = res.data.seriesHasMore;
            this.seriesPage = res.data.currentPage || 1;
            this.seriesList = res.data.seriesWithSelectedList || [];
          } else if (pageConditionType === "attribute") {
            // 属性
            this.conditionTypeObj.attributeHasMore = res.data.attributeHasMore;
            this.attributePage = res.data.currentPage || 1;
            if (page === 1) {
              this.attributeList = res.data.attributeWithSelectedList || [];
            } else {
              this.attributeList.push(
                ...(res.data.attributeWithSelectedList || [])
              );
            }
            const fList = new Array(this.attributeList.length).fill(false);
            const showMoreAttributeList = fList.map((item, index) => {
              return this.showMoreAttributeList[index] || item;
            });
            this.$set(this, "showMoreAttributeList", showMoreAttributeList);
          } else if (!pageConditionType) {
            this.conditionTypeObj = res.data;
            this.brandList = res.data.brandWithSelectedList || [];
            this.seriesList = res.data.seriesWithSelectedList || [];
            this.attributeList = res.data.attributeWithSelectedList || [];

            this.commodityCategoryTreeVo = {
              children: res.data.commodityCategoryTreeList || [],
            };
            this.getCategoryTree();

            this.showMoreAttributeList = new Array(
              this.attributeList.length
            ).fill(false);
            this.$set(
              this,
              "showMoreAttributeList",
              this.showMoreAttributeList
            );
          }
          this.$set(this, "conditionTypeObj", this.conditionTypeObj);
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 输出搜索条件
    postSearchParams() {
      const params = {
        search: this.$route.query.search || "", // 搜索内容
        brandIdList: this.brandIdList, // 品牌主键列表
        seriesNameList: this.seriesNameList, // 系列主键列表
        attributeNameValueList: this.attributeNameValueList, // 属性值主键列表
        salesDesc: this.salesDesc,
        priceDesc: this.priceDesc,
        collectedInfo: true,
        oldGoodsName: this.oldGoodsName,
        oldGoodsCode: this.oldGoodsCode,
        customerLabel: this.customerLabel,
      };

      let categoryId = this.foregroundCategoryId;
      if (this.categoryParentList && this.categoryParentList.length) {
        categoryId =
          this.categoryParentList[this.categoryParentList.length - 1]
            .categoryId;
      }
      params.foregroundCategoryId = categoryId;

      this.$emit("search", params);
    },
    // 更改类目
    choosedCategory(category, item) {
      // 一级
      if (category.categoryId === item.categoryId) {
        this.categoryParentList = [category];
      } else {
        // 二级
        const c = item.children.find(
          (i) => i.categoryId === category.categoryId
        );
        if (c) {
          this.categoryParentList = [item, category];
        } else {
          // 三级
          item.children.some((i) => {
            const c = (i.children || []).find(
              (j) => j.categoryId === category.categoryId
            );
            if (c) {
              this.categoryParentList = [item, i, category];
              return true;
            } else {
              return false;
            }
          });
        }
      }

      this.$router.push({
        name: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: category.categoryId,
          brandIdList: this.$route.query.brandIdList || "",
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeNameValueList:
            this.brandIdList.length || this.seriesNameList.length
              ? this.$route.query.attributeNameValueList
              : "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
          oldGoodsName: this.oldGoodsName,
          oldGoodsCode: this.oldGoodsCode,
          customerLabel: this.customerLabel,
        },
      });

      // this.getCategory();
    },
    setFirstCategory() {
      console.log("setFirstCategory:");
      this.categoryParentList = [];
      this.$router.push({
        name: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: "",
          brandIdList: this.$route.query.brandIdList || "",
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeNameValueList:
            this.brandIdList.length || this.seriesNameList.length
              ? this.$route.query.attributeNameValueList
              : "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
          oldGoodsName: this.oldGoodsName,
          oldGoodsCode: this.oldGoodsCode,
          customerLabel: this.customerLabel,
        },
      });

      // if (isSame) {
      this.getCategory();
      // }

      // this.getCategoryTree()
      // this.getCategory()
    },
    // 点击品牌
    choosedBrand(brand) {
      let brandId = brand.brandId + "";
      if (
        this.brandIdList &&
        this.brandIdList.length &&
        brandId + "" === this.brandIdList[0]
      ) {
        brandId = "";
      }
      this.$router.push({
        name: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: brandId,
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeNameValueList:
            !brandId &&
            !this.$route.query.seriesNameList &&
            (this.categoryParentList.length === 1 ||
              this.categoryParentList.length === 0)
              ? ""
              : this.$route.query.attributeNameValueList || "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
          oldGoodsName: this.oldGoodsName,
          oldGoodsCode: this.oldGoodsCode,
          customerLabel: this.customerLabel,
        },
      });
    },
    // 点击更改系列
    choosedSeries(item) {
      this.$router.push({
        name: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList || "",
          seriesNameList: item.selected ? "" : item.name + "",
          attributeNameValueList:
            !this.$route.query.brandIdList &&
            item.selected &&
            (this.categoryParentList.length === 1 ||
              this.categoryParentList.length === 0)
              ? ""
              : this.$route.query.attributeNameValueList || "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
          oldGoodsName: this.oldGoodsName,
          oldGoodsCode: this.oldGoodsCode,
          customerLabel: this.customerLabel,
        },
      });
    },
    // 点击更改属性
    choosedAttribute(attItem) {
      let attributeNameValueList = this.attributeNameValueList;
      if (attItem.selected) {
        let index = attributeNameValueList.findIndex((item) => {
          return item + "" === attItem.attributeValueId + "";
        });
        if (index > -1) {
          attributeNameValueList.splice(index, 1);
        }
      } else {
        attributeNameValueList.push(attItem.attributeValueId);
      }
      this.$router.push({
        name: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList || "",
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeNameValueList: attributeNameValueList.join("^^"),
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
          oldGoodsName: this.oldGoodsName,
          oldGoodsCode: this.oldGoodsCode,
          customerLabel: this.customerLabel,
        },
      });
    },
    // 默认排序
    defaultSortHandle() {
      this.salesDesc = "";
      this.priceDesc = "";
      this.popularityDesc = "";
      this.$router.push({
        name: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList,
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeNameValueList:
            this.$route.query.attributeNameValueList || "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
          oldGoodsName: this.oldGoodsName,
          oldGoodsCode: this.oldGoodsCode,
          customerLabel: this.customerLabel,
        },
      });
    },
    // 更改排序
    changeSortStatus(type) {
      const sortList = ["", "true", "false"];
      const findIndex = sortList.findIndex((item) => {
        return item === this[type];
      });
      if (type === "salesDesc") {
        this.salesDesc = sortList[findIndex + 1 > 2 ? 0 : findIndex + 1];
      } else if (type === "priceDesc") {
        this.priceDesc = sortList[findIndex + 1 > 2 ? 0 : findIndex + 1];
      } else if (type === "popularityDesc") {
        this.popularityDesc = sortList[findIndex + 1 > 2 ? 0 : findIndex + 1];
      }

      this.$router.push({
        name: this.pageName,
        query: {
          search: this.$route.query.search,
          foregroundCategoryId: this.$route.query.foregroundCategoryId || "",
          brandIdList: this.$route.query.brandIdList,
          seriesNameList: this.$route.query.seriesNameList || "",
          attributeNameValueList:
            this.$route.query.attributeNameValueList || "",
          salesDesc: this.salesDesc,
          priceDesc: this.priceDesc,
          popularityDesc: this.popularityDesc,
          oldGoodsName: this.oldGoodsName,
          oldGoodsCode: this.oldGoodsCode,
          customerLabel: this.customerLabel,
        },
      });
    },
    setParams(obj) {
      this.attributePage = obj.attributePage;
    },
  },
};
</script>
<style lang="scss" scoped>
.home_page {
  // position: relative;
  // padding-top: 72px;
  font-family: Alibaba PuHuiTi;
}
.goods_category_list {
  margin-top: 10px;
  line-height: 30px;
  font-size: 14px;
  border-radius: 12px;
  background: #ffffff;
  // box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  padding: 16px 20px;
  background: #f9fafb;
  font-family: Alibaba PuHuiTi;
  .search_title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 16px;
  }
  .category_row {
    // background: #fff;
    display: flex;

    // border-radius: 12px;
    // background: #FFFFFF;
    // box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);

    .row_lable {
      // color: #333333;
      overflow: hidden;
      width: 110px;
      padding-right: 10px;
      // font-weight: bold;
      // padding-top: 16px;
      // line-height: 19px;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      font-weight: 500;
      line-height: 33px;
      height: 33px;
      letter-spacing: 0px;
      color: #666666;
    }
    .choosed_category_item {
      display: flex;
      align-items: center;
      height: 28px;
    }
    // 已选中的类目展示
    .category_next {
      margin-left: 5px;
    }
    .choosed_category {
      border: 1px solid #2e88ff;
      margin-left: 5px;
      display: flex;
      height: 20px;
      line-height: 20px;
      // align-items: center;
      .choosed_category_name {
        padding: 0px 10px;
        line-height: 18px;
      }
      .category_close {
        background: #2e88ff;
        color: #fff;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .category-item {
      text-align: center;
      display: flex;
      align-items: center;
      width: 11%;
      // padding: 6px 8px;
      margin-right: 12px;
      margin-bottom: 16px;
      .item_span {
        padding: 6px 8px;
        font-size: 14px;
        line-height: 16px;
        width: 100%;
        float: left;
        color: #333;
        border: 1px solid #cccccc;
        border-radius: 8px;
        box-sizing: border-box;
      }
      .item_select {
        color: #ffffff;
        font-size: 12px;
        font-weight: 500;
        background: #2a54d1;
      }
      .category-item-button {
        height: 21px;
        line-height: 21px;
        padding: 0 11px;
        color: #2e88ff;
        border-color: #2e88ff;
      }
    }
    .category-item_select {
      color: #ffffff;
      font-size: 12px;
      font-weight: 500;
      background: #2a54d1;
    }
    .category-more {
      text-align: right;
      display: flex;
      justify-content: flex-end;
      // width: calc(100% - 110px -);
      flex: 1;
      .more-button {
        padding: 6px 5px 0 0;
        line-height: 16px;
        text-align: center;
        // background: #ffffff;
        // border: 1px solid #cccccc;
        border-radius: 4px;
        // line-height: 20px;
        // margin: 5px;
        padding: 5px 10px;
        display: inline;
        color: #333333;
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
}
.search_show_more_box {
  text-align: center;
  display: flex;
  justify-content: flex-end;
  .search_show_more {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;
    color: #333333;
    display: flex;
    align-items: center;
    height: 22px;
    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 1;
    }
    img {
      width: 16px;
      margin-left: 4px;
      margin-top: -2px;
    }
  }
  .search_show_more_down {
    img {
      transform: rotate(180deg);
    }
  }
}
.good_sort {
  margin: 10px 0 20px;
  line-height: 32px;
  color: #666666;
  border-radius: 12px;
  display: flex;
  padding: 10px 20px;
  background: #fff;
  margin-top: 12px;
  // box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  font-size: 14px;
  background: #f9fafb;
  .default_sort_but {
    display: flex;
    align-items: center;
    color: #666666;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #cccccc;
    border-radius: 8px;
    font-size: 14px;
    margin-right: 12px;
    height: 32px;
  }
  .good_sort_default {
    color: #2a54d1;
    border: 1px solid #2a54d1;
  }
  .sort_item {
    display: flex;
    justify-content: center;
    height: 32px;
    align-items: center;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #cccccc;
    border-radius: 8px;
    margin-right: 12px;

    .sort_status {
      margin-left: 5px;
      font-size: 12px;
      transform: scale(0.7);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #bebebe;
      .sort_status_selected {
        color: #333333;
      }
    }
  }
  .sort_item_selected {
    color: #2a54d1;
    border: 1px solid #2a54d1;
  }
  .input-search {
    width: auto;
    margin-right: 12px;
    ::v-deep .el-input__inner {
      width: 96px;
      height: 32px;
      box-sizing: border-box;
      border: 1px solid #cccccc;
      border-radius: 8px;
      padding: 6px 12px;
    }
    ::v-deep .el-input__icon {
      // height: 36px;
      transform-origin: center;
    }
    ::v-deep .el-input__suffix {
      display: flex;
      align-items: center; /* 垂直居中 */
    }
  }
  .select-search {
    width: auto;
    margin-right: 12px;
    ::v-deep .el-input__inner {
      width: 192px;
      height: 32px;
      box-sizing: border-box;
      border: 1px solid #cccccc;
      border-radius: 8px;
      padding: 6px 12px;
    }
    ::v-deep .el-input__icon {
      transform-origin: center;
    }
    ::v-deep .el-input__suffix {
      display: flex;
      align-items: center; /* 垂直居中 */
    }
  }
}

.letter {
  .letter-item {
    padding: 0 7px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    cursor: pointer;
  }
  .letter-choosed {
    color: #028df9;
  }
}
.rel {
  position: relative;
}
.selected-wrap {
  // position: absolute;
  width: 1190px;
  // top: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 4px;
  align-items: center;
  border-radius: 12px;
  background: #f9fafb;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  padding: 16px 20px;
  margin-top: 12px;
  .selected-lable {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #666666;
    margin-right: 30px;
  }

  .clear-all {
    width: 110px;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 27px;
    border-radius: 4px;
    font-size: 14px;
    // color: #2a54d1;
    margin-left: 12px;
    cursor: pointer;
    color: #333333;
    font-size: 14px;
    img {
      width: 16px;
      height: 16px;
      margin-top: -1px;
    }
    &:hover {
      opacity: 0.8;
    }
  }
}
.selected {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}

.child-item {
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 0 8px;
  height: 27px;
  margin: 0 12px 0 0;
  font-size: 14px;
  background: #f9fafb;
  border-radius: 8px;
  font-weight: bold;
  color: #333333;

  span {
    font-weight: 400;
    color: #666666;
  }

  .line {
    width: 1px;
    height: 16px;
    background: #cccccc;
    margin: 0 8px;
  }
  .cancel {
    width: 16px;
    height: 16px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}

.rf {
  padding-bottom: 12px;
}
</style>
